export default {
  isLogin(state, payload) {
    state.isLogin = payload
  },
  //设置顶部导航栏菜单激活
  setIndex(state, payload) {
    state.showIndex = payload
  },

  //设置用户信息
  setUser(state, payload) {
    state.user = payload
  },

  //设置用户id
  setUserId(state, payload) {
    state.userId = payload.toString()
  },

}